import React, { memo } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cn from 'classnames';
import { AffirmPromo, AFFIRM_PROMO_TYPES } from 'src/components/Affirm';
import ProductPriceGuarantee from '../ProductHeader/ProductPriceGuarantee';

const ProductPriceLegacyMain = ({ service }) => {
  const {
    listPrice: { formatted: formattedListPrice, value: listPriceValue },
    cheapestPrice,
    basePrice: basePriceValue,
  } = service;

  const listPrice = listPriceValue / 100;
  const basePrice = basePriceValue / 100;
  const isPriceDiscounted = listPrice > basePrice;
  const amountSaved = (listPrice - basePrice).toFixed(2);
  const affirmPrice = get(service, 'basePrice');

  return (
    <>
      <ProductPriceGuarantee className="marginTop-small1 marginBottom-tiny"/>
      <div className={cn('marginBottom-tiny1 flex alignItemsCenter')}>
        <h4>${cheapestPrice}</h4>
        {!!listPriceValue && isPriceDiscounted && (
          <>
            <p className="paddingX-tiny1 line-through n700 caption">{formattedListPrice}</p>
            <p className="p2 successGreen500">Save ${amountSaved}</p>
          </>
        )}
      </div>
      <AffirmPromo
        className="p2 marginBottom-small2"
        type={AFFIRM_PROMO_TYPES.product}
        amount={affirmPrice}
      />
    </>
  );
};

ProductPriceLegacyMain.propTypes = {
  service: PropTypes.object,
};

export default memo(ProductPriceLegacyMain);
